export const environment = {
	production: false,
	API_GENERAL_URL: 'https://clip-api.3cubehealth.com/',
	MANTRA_FINGERPRINT_DEVICE_URL: 'https://localhost:8003/mfs100/',
	defaultToMail: "yogesh.kapase@technicious.in",
	FIX_TOKEN: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzEzMDg1MDYyLCJpYXQiOjE2ODE1NDkwNjIsInVzZXJfaWQiOjEsImp0aSI6IjhjMTM0YWE2ZTkxZjRlMzg5ZGQ0ZTM1ODkxZTY4Y2FhIn0.B78GgwNNwIAOVDbEnqTW8SLTrOsMBHcct-7RRrNzsf8",
	owners: [
		{ name: "dr_tiwari", id: 1 },
		{ name: "drsc", id: 5 },
		{ name: "philips", id: 7 },
		{ name: "philips", id: 25 },
		{ name: "Kanwar", id: 8 },
		{ name: "3Cube", id: 9 },
		{ name: "chaudhari", id: 10 },
		{ name: "sahijwala", id: 3 },
		{ name: "pol", id: 11 },
	],
	showAccess: ["Doctor", "Staff", "Consultant", "Pathologist", "Radiologist", "Cardiologist", "Dentist", "Accountant", "Network", "Orthopedic", "Physiotherapist"],
	witnessId: 20,
	repTypeUSDId: 20,
	repTypeUSDId1: 21,
	firebaseConfig: {
		vapiKey: "BMzX1bIzWhRT8jrj2OWhOyJNr5TMOC2zkxPjzo4FqIfC-EnROn4nN2d11nUDmGWskFrpyTNiXtHPkxG6YdEy3A0",
		apiKey: "AIzaSyBhdT_ZB8NwFHDNkYzRB0zf8FLamvvLkzU",
		authDomain: "clip-staging-2f0d1.firebaseapp.com",
		projectId: "clip-staging-2f0d1",
		storageBucket: "clip-staging-2f0d1.firebasestorage.app",
		messagingSenderId: "844616444209",
		appId: "1:844616444209:web:93645c39147f1fced2a810",
		measurementId: "G-J15C3PKR6W"
	},
	fire_u: "yogesh.kapase@technicious.in",
	fire_p: "Tech@123",
	email_id: "helpdesk@emails.3cubehealth.com",
};